import { FC, useState } from 'react';
import classNames from 'classnames';
import { MenuOutlined } from '@ant-design/icons';

import { SideBar } from '../SideBar';

import styles from './index.module.scss';

type HeaderProps = {
	children: JSX.Element;
	email?: string;
	notFound?: boolean;
};

export const Header: FC<HeaderProps> = ({ children, email, notFound }) => {
	const [isOpen, setIsOpen] = useState(false);

	return (
		<div className={styles.top}>
			{children}

			<div
				aria-label="sidebar"
				role="button"
				className={classNames(styles.button, { [styles.buttonHidden]: email && !notFound })}
				onClick={() => {
					setIsOpen(true);
				}}
			>
				<MenuOutlined />
			</div>

			<SideBar onClose={() => setIsOpen(false)} visible={isOpen} />
		</div>
	);
};
